import React from 'react';

// Mobx
import { inject, observer } from 'mobx-react';

// FlatList
import DataTable from 'react-data-table-component';

// Navigation
import { useNavigate, Navigate, Link } from 'react-router-dom';

// Helpers
import Helpers from '../../helpers';

// Css
import '../../assets/css/app.css';

// Layout
import CommerceLayout from '../layouts/CommerceLayout';

// Components
import FunctionalButton from '../../components/Buttons/FunctionalButton';
import SearchForm from '../../components/SearchForm';
import LoginForm from '../../components/LoginForm';

@inject('AuthStore', 'OrderStore')
@observer

class Orders extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {
        if (Helpers.objectToArray(this.props.OrderStore.orders.content).length === 0) {
            Helpers.getOrders();
        }
    }

    render() {
        const storeId = localStorage.getItem('storeId');

        return (
            storeId !== null ?
                <CommerceLayout
                    title={Helpers.translation('my_orders')}
                    visibleCategories={false}
                >
                    {
                        this.props.AuthStore.userData.isLogin ?
                            <section id="shop">
                                <div className="container mx-auto p-4">
                                    <div className="flex flex-col">
                                        <div className="w-full mt-4">
                                            <SearchForm
                                                inputs={[
                                                    {
                                                        type: "text",
                                                        name: "code",
                                                        placeholder: Helpers.translation('code'),
                                                    },
                                                    {
                                                        type: "dateBetween",
                                                        name: "createdAt",
                                                        placeholder: Helpers.translation('created_at'),
                                                    },
                                                ]}
                                                sendFunction={Helpers.searchOrders}
                                                store={this.props.OrderStore}
                                                inFilters={[
                                                    `filters[user][changeIndex]=${Helpers.getUserData().id}`,
                                                    `filters[store][changeIndex]=${storeId}`,
                                                ]}
                                                autoSend={true}
                                            />

                                            <DataTable
                                                columns={[
                                                    {
                                                        name: Helpers.translation('code'),
                                                        selector: (row: any) => row.code,
                                                    },
                                                    {
                                                        name: Helpers.translation('created_at'),
                                                        selector: (row: any) => Helpers.explodeDate(row.createdAt).dateTime,
                                                    },
                                                    {
                                                        name: Helpers.translation('payment_type'),
                                                        selector: (row: any) => row.payment_type.data.attributes.title,
                                                    },
                                                    {
                                                        name: Helpers.translation('price'),
                                                        selector: (row: any) => {
                                                            let price = 0;
                                                            let discount = 0;

                                                            Helpers.objectToArray(row.product_datas).map((productData: any, index: number) => {
                                                                price = price + productData.grand_total;
                                                                discount = discount + productData.discount_amount;
                                                            });

                                                            return Helpers.multiplyStringNumber((price - discount), 1) + row.currency.data.attributes.symbol;
                                                        },
                                                    },
                                                    {
                                                        name: Helpers.translation('transactions'),
                                                        selector: (row: any) => {
                                                            return (
                                                                <div className="grid grid-cols-2 gap-1">
                                                                    <Link to={`/orders/${row.id}`}>
                                                                        <FunctionalButton
                                                                            text={Helpers.translation('details')}
                                                                            rounded
                                                                            customClasses="text-xs"
                                                                        />
                                                                    </Link>
                                                                </div>
                                                            )
                                                        },
                                                    },
                                                ]}
                                                data={
                                                    this.props.OrderStore.searchFilterText !== "" ?
                                                        Helpers.objectToArray(this.props.OrderStore.searchOrders.content).reverse()
                                                        :
                                                        Helpers.objectToArray(this.props.OrderStore.orders.content).reverse()
                                                }
                                            />

                                            {
                                                this.props.OrderStore.searchFilterText !== "" ?
                                                    (Helpers.objectToArray(this.props.OrderStore.searchOrders.content).length >= 1 && this.props.OrderStore.searchOrders.page <= this.props.OrderStore.searchOrders.pageCount) &&
                                                    <div className="w-full flex flex-row justify-center items-center mt-2">
                                                        <FunctionalButton
                                                            onPress={() => Helpers.searchOrders()}
                                                            text={Helpers.translation('show-more')}
                                                            rounded
                                                        />
                                                    </div>
                                                    :
                                                    (Helpers.objectToArray(this.props.OrderStore.orders.content).length >= 1 && this.props.OrderStore.orders.page <= this.props.OrderStore.orders.pageCount) &&
                                                    <div className="w-full flex flex-row justify-center items-center mt-2">
                                                        <FunctionalButton
                                                            onPress={() => Helpers.getOrders()}
                                                            text={Helpers.translation('show-more')}
                                                            rounded
                                                        />
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </section>
                            :
                            <LoginForm
                                message={Helpers.translation('you_need_login_for_view_this_page')}
                            />
                    }
                </CommerceLayout>
                :
                <Navigate to="/" replace={true} />
        )
    }
}

function WithNavigate(props: any) {
    let navigate = useNavigate();
    return <Orders {...props} navigate={navigate} />
}

export default WithNavigate;